import { makeMarkdownText } from '@assistant-ui/react-ui';
import { memo, useMemo } from 'react';
import {
  createMarkdownComponents,
  markdownRehypePlugins,
  markdownRemarkPlugins,
  useMarkdownStyles,
} from './markdown-theme';

const MarkdownTextImpl = () => {
  const className = useMarkdownStyles();
  const Markdown = useMemo(
    () =>
      makeMarkdownText({
        className,
        components: createMarkdownComponents(),
        rehypePlugins: markdownRehypePlugins,
        remarkPlugins: markdownRemarkPlugins,
        skipHtml: true,
      }),
    [className],
  );

  return <Markdown />;
};

export const MarkdownText = memo(MarkdownTextImpl);
